<template>
	<div class="game">

		<Header/>

		<main role="main" id="main" class="app-main" v-bind:class="{'extended': extended}">

			<div class="app-view full" :class="$route.name == 'main' ? 'active' : ''">

				<Map :extra-class="map_extra_class"/>

				<SlidingPanelAssets :is-opened="is_opened_asset_panel" @onToggleOpen="toggleOpenAssetPanel" :state="$route.params.id ? $route.params.id : 'people'"/>
				<Trace v-if="$auth.hasAccess('trace')"></Trace>
				<AlertControl v-if="assets_loaded"/>
				<SlidingPanel condition="asset-log=*" v-if="$auth.hasAccess('profile-panel')">
					<ProfilePanel />
				</SlidingPanel>
				<ActionsPanel :is-opened="side_panel_open" v-if="assets_loaded" />
				<DayControl/>
				<Message/>

			</div>

			<SaveControl v-if="drawLayer"/>


			<div class="app-view" :class="$route.name == 'project' ? 'active' : ''" v-if="$auth.hasAccess('project')">
				<Project v-if="assets_count && $route.name == 'project'" />
			</div>



		</main>

		<FooterBlock :timeInterface="true" />
		<ReportData v-if="$auth.hasAccess('project') && assets_loaded" />

		<b-modal ref="error-modal" title="Game Error" v-model="error" class="">

			<div class="alert alert-danger">
				<span v-if="error === true"> An error has occurred. Please try again later.</span>
				<span v-else>{{error}}</span>
			</div>

			<div slot="modal-footer">
				<button type="button" class="btn btn-secondary" @click="error=false">Close</button>
			</div>

		</b-modal>

		<Simulator />


	</div>
</template>

<style scoped lang="scss" rel="stylesheet/scss">
	html, body {
		-webkit-transform: translateZ(0);
	}

	.assets-panel-container {
		border: 1px solid red;
	}
	.game {
		position: absolute;
		width: 100%;
		height: 100vh;
		top: 0;
		left: 0;
	}
	.app-main {
		background: #fff;
		height: calc(100% - 97px - 67px);
		position: relative;
		width: 100%;
		top: 0;
		transition: height 0.4s;
		margin-top: 97px;
		&.extended {
			height: calc(100% - 97px);
		}
		.app-view {
			position: absolute;
			width: 100%;
			height: 100%;
			background: #fff;
			z-index: -1;
			top: 0;
			opacity:0;
			transition: opacity 0.5s linear;
			overflow-y: auto;
			&.active {
				position: initial;
				z-index: 999;
				display: block;
				opacity: 1;
			}
			&.full {
				overflow-y: hidden;
			}
		}
	}
</style>

<script>

	import Map from '../../components/Map/Map.vue'
	import Watchers from '../../components/Game/Workers/Watchers.js'
	import Project from '../../components/Views/Project.vue'
	import Header from './Header'
	import SlidingPanel from '../../components/widgets/SlidingPanel.vue'
	import SlidingPanelAssets from '../../components/Views/AssetsPanel'
	import ActionsPanel from '../../components/Game/ActionsPanel.vue'
	import FooterBlock from './Footer.vue'
	import ProfilePanel from '../../components/Game/ProfilePanel.vue'
	import AlertControl from '../../components/Game/AlertControl.vue'
	import DayControl from '../../components/Game/DayControl.vue'
	import SaveControl from '../../components/Game/SaveControl.vue'
	import Simulator from '../../components/Game/Simulator.vue'
	import Trace from '../../components/Game/Trace'
	import ReportData from '../../components/Game/ReportData.vue'
	import Message from '../../components/Game/Message'

	import * as workerTimers from 'worker-timers';


	export default {
		name: 'App',
		data() {
			return {
				is_location: true,
				short_clock: '',
				map_to: null
			}
		},
		mixins: [Watchers],
		watch: {
			'$route': {
				handler(to) {
					if (to.path.indexOf('/assets') !== -1 && !this.is_opened_asset_panel) {
						this.is_location = false;
						this.is_opened_asset_panel = true;
						this.side_panel_open = false;
						if (this.map) this.updateSizeMap();
					} else {
						this.is_location = true;
						this.is_opened_asset_panel = false;
						this.side_panel_open = true;
						if (this.map) this.updateSizeMap();
					}
				},
				immediate: true
			},
			time() {
				let moment_time = this.moment(this.start_date).add(this.day - 1, 'days').hour(this.start_time.hour).minute(this.start_time.minute).second(this.time);
				this.short_clock = moment_time.format("h:mm a");
			},
			side_panel_open() {
				this.updateSizeMap();
			}
		},
		async mounted() {
			if (this.$route.path.indexOf('/assets') !== -1 && !this.is_opened_asset_panel) {
				this.is_opened_asset_panel = true;
				this.updateSizeMap();
			}
			this.short_clock = this.moment(this.start_date).add(this.day - 1, 'days').hour(this.start_time.hour).minute(this.start_time.minute).second(this.time).format("h:mm a");
			this.clock = this.moment(this.start_date).add(this.day - 1, 'days').hour(this.start_time.hour).minute(this.start_time.minute).second(this.time).format("M/D/YY h:mm:ssa");

			await this.setData();
		},
		computed: {
			location() { return this.$store.state.location },
			map_extra_class() {
				const {side_panel_open, is_opened_asset_panel} = this;
				return [
					side_panel_open ? 'action-panel-open': '',
					is_opened_asset_panel ? 'assets-panel-open': ''
				].filter( cl => cl !== '').join(' ');
			},
			map() { return this.$store.state.map.map },
			time() { return this.$store.state.time },
			assets_count() { return Object.keys(this.$store.state.workers).length},
			day() { return  this.$store.state.day },
			start_time() { return this.$config.start_time},
			end_time() { return this.$config.end_time},
			start_date() { return this.$store.state.start_date },
			clock: {
				get() { return  this.$store.state.clock },
				set(value) { this.$store.commit('setState', ['clock', value])}
			},
			speed: {
				get() { return  this.$store.state.speed },
				set(value) { this.$store.commit('set_speed', value)}
			},
			alert() { return this.$finder.all({'status': 'pending'}, this.$store.state.alert) },
			extended: {
				get(){ return this.$store.state.bottom_menu_collapsed }
			},
			drawLayer() { return this.$store.state.map.drawLayer },
			side_panel_open: {
				get() { return this.$store.state.side_panel_open },
				set(value) { this.$store.commit('setState', ['side_panel_open', value])}
			},
			assets_loaded() { return this.$store.state.assets_loaded },
			error: {
				get() { return this.$store.state.error },
				set(value) { this.$store.commit('setState', ['error', value])}
			},
			paths: {
				get() { return this.$store.state.paths},
				set(value) {
					this.$store.commit('setState', ["paths", value]);
				}
			},
			vehicle_types: {
				get() { return this.$store.state.vehicle_types},
				set(value) {
					this.$store.commit('setState', ["vehicle_types", value]);
				}
			},
			zones: {
				get() { return this.$store.state.zones},
				set(value) {
					this.$store.commit('setState', ["zones", value]);
				}
			},
			schedule: {
				get() { return this.$store.state.schedule},
				set(value) {
					this.$store.commit('setState', ["schedule", value]);
				}
			},
			floors: {
				get() { return this.$store.state.floors},
				set(value) {
					this.$store.commit('setState', ["floors", value]);
				}
			},
			companies: {
				get() { return this.$store.state.companies },
				set(value) { this.$store.commit('setState', ['companies', value])}
			},
			user() {
				return this.$store.state.user
			},
		},
		methods: {
			updateSizeMap() {
				const {map} = this;
				this.map_to = setInterval(() =>{
					map.updateSize();
				},1);

				setTimeout(() => {
					if (this.map_to !== null) clearInterval(this.map_to);
					this.map_to = null;
				}, 450);
			},
			toggleOpenAssetPanel() {
				this.is_opened_asset_panel = !this.is_opened_asset_panel;
			},
			async setData() {
				let companies = this.location.companies ? this.location.companies : this.$config.companies;
				if (this.user.role[0] != "super manager") {
					this.companies = [];
					for (let i in companies) {
						if (this.user.company.includes(companies[i].id)) this.companies.push(companies[i]);
					}
				}
				else this.companies = companies;

				this.vehicle_types = this.$config.vehicle_types;

				let paths = require(`../../config/scenarios/${this.location.id}/paths.json`);
				this.paths = Object.assign(this.paths, paths);

				let floors = require(`../../config/scenarios/${this.location.id}/floors.json`);
				this.floors = Object.assign(this.floors, floors);

				let zones = require(`../../config/scenarios/${this.location.id}/zones.json`);
				this.zones = Object.assign(this.zones, zones);

				let schedule = require(`../../config/scenarios/${this.location.id}/schedule.json`);
				this.schedule = Object.assign(this.schedule, schedule);
			}
		},
		components: {Map, Project, FooterBlock, ProfilePanel, AlertControl, DayControl, SlidingPanel, SlidingPanelAssets, ActionsPanel, SaveControl, Header, Trace, Simulator, ReportData, Message}
	}
</script>
